import { ref } from 'vue';

export default function useEditorColors({ editor, disabled }) {
  const highlight_picker_ref = ref(null);
  const text_color_picker_ref = ref(null);
  const show_highlight_menu = ref(false);
  const show_text_color_menu = ref(false);

  function toggleHighlightMenu(event) {
    if (disabled.value) return;
    highlight_picker_ref.value.toggle(event);
    show_highlight_menu.value = !show_highlight_menu.value;
  }

  function setHighlightColor(color) {
    if (!editor.value) return;
    editor.value.chain().focus().setHighlight({ color }).run();
    show_highlight_menu.value = false;
  }

  function removeHighlight() {
    if (!editor.value) return;
    editor.value.chain().focus().unsetHighlight().run();
    show_highlight_menu.value = false;
  }

  function closeHighlightMenu() {
    show_highlight_menu.value = false;
  }

  function toggleTextColorMenu(event) {
    if (disabled.value) return;
    text_color_picker_ref.value.toggle(event);
    show_text_color_menu.value = !show_text_color_menu.value;
  }

  function setTextColor(color) {
    if (!editor.value) return;
    editor.value.chain().focus().setColor(color).run();
    show_text_color_menu.value = false;
  }

  function removeTextColor() {
    if (!editor.value) return;
    editor.value.chain().focus().unsetColor().run();
    show_text_color_menu.value = false;
  }

  function closeTextColorMenu() {
    show_text_color_menu.value = false;
  }

  return {
    highlight_picker_ref,
    text_color_picker_ref,
    show_highlight_menu,
    show_text_color_menu,
    toggleHighlightMenu,
    setHighlightColor,
    removeHighlight,
    closeHighlightMenu,
    toggleTextColorMenu,
    setTextColor,
    removeTextColor,
    closeTextColorMenu,
  };
}
